export default __webpack_public_path__ + "static/media/affiche.7857837e.jpg";